import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
import {
  Tabs,
  Tab,
  TextField,
  InputAdornment,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
} from '@material-ui/core';
import classNames from 'classnames';
import { connect } from 'react-redux';
import _ from 'lodash';

import {API, CONSOLE} from "../../../../config";
import Utils from "../../../../yeffect/utils"

const OpenBuyOrders = API.service('buy-orders');
const OpenSellOrders = API.service('sell-orders');
const CompletedTrades = API.service('completed-trades');
const Companies = API.service('company');

const moment = require('moment');

const styles = theme => ({
  container: {
    flex: '1 0 auto',
  },
  tabRoot: {
    minWidth: 100,
  },
  tabcontent: {
    borderTop: "1px solid #1890ff"
  },
  row: {
    height: "auto",

    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default
    }
  },
  cell: {
    padding: '4px 8px 4px 8px',
    cursor: 'pointer'
  },
  margin: {
    margin: '20px 10px',
  },
  textField: {
    flex: 'none',
    width: 'calc(100% - 20px)',
  },
})

class OrderList extends Component {
  state = {
    selectedOrderTab: 0,
    openOrder: [],
    completedOrder: [],
    sortIndex: 0, // Sort index of first tab's table
    sortOrder: -1, // Sort order of first tab's table
    sortIndex_1: 0, // Sort index of second tab's table
    sortOrder_1: -1, //Sort order of second tab's table
    query: '',
    currency:false,
    cross_broker:[]
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.selectedCompany) {
      const { selectedCompany } = nextProps;
      if (this.state.select !== selectedCompany.account_number) {
        this.setState({
          select: selectedCompany.account_number,
        });
        this.updateData()
      }
    }
  }

  updateData() {
    const app = this;
    let order = [];
    let query = {};

    if(this.props.selectedCompany){
      query = {_company_account:this.props.selectedCompany.account_number}
    } else {
      query ={};
    }
    Companies.find({query:{$limit:10000}}).then(c=> {
      console.log("companies:",c.data);
      let comps = {};
      c.data.forEach(company => {
        comps[company._company_account] = company;
      })
    console.log("resolved",comps)
      OpenBuyOrders.find({
        query: {
          incl: ['broker'],
          $sort: {_ts_order_posted: -1},
          _status: 0,
          $limit: 50, ...query
        }
      }).then(bo => {
        OpenSellOrders.find({
          query: {
            $sort: {_ts_order_posted: -1},
            _status: 0,
            incl: ['broker', 'company'],
            $limit: 50, ...query
          }
        }).then(so => {
          order = [...bo.data, ...so.data];
          CONSOLE(order);
          order = _.orderBy(order, ['_ts_order_posted'], ['asc']);

          app.setState({
            openOrder: order.map(o => {
              if (_.isEmpty(o.Authorized_Brokers)) {
                o.Authorized_Brokers.push({_name: '-'});
              }
              if (_.isEmpty(o.Companies)) {
                o.Companies = [];
                o.Companies.push({_company_symbol: '-'});
              }

              return o;
            }),
            companies:comps
          }, () => this._filterOrder());
        });
      });

      var complete = [];
      CompletedTrades.find({query: {$sort: {createdAt: -1}, $limit: 20, ...query, incl: ['brokers']}}).then(ct => {
        complete = _.merge(ct.data, complete);
        complete = _.orderBy(complete, ['_ts_executed'], ['desc']);

        app.setState({
          completedOrder: complete,
          companies:comps
        }, () => this._filterOrder());
      })
    })
    let addQuery = {};
    if(this.props.selectedCompany){
      addQuery = {_company_account:this.props.selectedCompany.account_number}
    }

    CompletedTrades.find({ query: { type:'CrossBroker',...addQuery , startDate:'2019-01-10'} }).then(ct => {
      console.log('blahblah',ct);
      app.setState({
        cross_broker : ct
      })
    })
  }

  componentDidMount() {
    const app = this;
    window.addEventListener("resize", () => {
      this.setState({ windowHeight: window.innerHeight - 122 })
    });

    app.updateData();

    app.time = setInterval(function () {
      app.updateData()
    }, 5000)
  }

  componentWillUnmount() {
    clearInterval(this.time);
  }

  handleTabChangeSecondary = (event, selectedOrderTab) => {
    this.setState({ selectedOrderTab, query: '' }, () => this._filterOrder());
  };

  handleSort = (id) => ev => {
    const { sortOrder, selectedOrderTab, sortOrder_1 } = this.state;

    if (!selectedOrderTab) {
      this.setState({ sortIndex: id, sortOrder: -sortOrder });
    } else {
      this.setState({ sortIndex_1: id, sortOrder_1: -sortOrder_1 });
    }
  };

  _filterOrder = () => {
    const { selectedOrderTab, openOrder, completedOrder } = this.state;

    if (!selectedOrderTab) {
      this.setState({
        openOrder: openOrder.filter(order => this._checkIfResult([
          order.Authorized_Brokers[0]._name,
          order.Companies[0]._company_symbol,
          (typeof order['_sell_order_confirmation'] === 'undefined') ? 'buy' : 'sell',
          order._type,
        ])),
      });
    } else {
      this.setState({
        completedOrder: completedOrder.filter(order => this._checkIfResult([
          order._selling_investor_account,
          order.Selling_Broker[0]._name,
          order._buying_investor_account,
          order.Buying_Broker[0]._name,
        ])),
      });
    }
  };

  handleQueryChange = (ev) => {
    this.setState({ query: ev.target.value.toLowerCase() }, () => this._filterOrder());
  };

  _checkIfResult = (arr) => {
    const { query } = this.state;

    for (let i of arr) {
      if (i.toString().toLowerCase().includes(query)) {
        return true;
      }
    }

    return false;
  }

  render() {

    const { classes, fullHeight } = this.props
    const {
      sortIndex,
      sortOrder,
      openOrder,
      sortIndex_1,
      sortOrder_1,
      completedOrder,
    } = this.state;

    const sortIcon = sortOrder === 1 ? <span>&#x25BC;</span> : <span>&#x25B2;</span>;
    const sortIcon_1 = sortOrder_1 === 1 ? <span>&#x25BC;</span> : <span>&#x25B2;</span>;

    //eslint-disable-line no-use-before-define
    openOrder.sort((left, right) => {
      switch (sortIndex) {
        case 0:
          return (moment(right._ts_order_sent) > moment(left._ts_order_sent) ? 1 : -1) * sortOrder;
        case 1:
          return (right.Authorized_Brokers[0]._name > left.Authorized_Brokers[0].name ? 1 : -1) * sortOrder;
        case 2:
          return (right.Companies[0]._company_symbol > left.Companies[0]._company_symbol ? 1 : -1) * sortOrder;
        case 3:
          return (right._price > left._price ? 1 : -1) * sortOrder;
        case 4:
          return (right._quantity > left._quantity ? 1 : -1) * sortOrder;
        case 5:
          return (typeof right['_sell_order_confirmation'] !== typeof left['_sell_order_confirmation'] ? 1 : -1) * sortOrder;
        case 6:
          return (right._type > left._type ? 1 : -1) * sortOrder;
        default:
          return right.id - left.id;
      }
    });
    completedOrder.sort((left, right) => {
      switch (sortIndex_1) {
        case 0:
          return (moment(right._ts_executed) > moment(left._ts_executed) ? 1 : -1) * sortOrder_1;
        case 1:
          return (right._selling_investor_account + ' ' + right.Selling_Broker[0]._name > left._selling_investor_account + ' ' + left.Selling_Broker[0]._name ? 1 : -1) * sortOrder_1;
        case 2:
          return (right._buying_investor_account + ' ' + right.Buying_Broker[0]._name > left._buying_investor_account + ' ' + left.Buying_Broker[0]._name ? 1 : -1) * sortOrder_1;
        case 3:
          return (right._quantity > left._quantity ? 1 : -1) * sortOrder_1;
        case 4:
          return (right._price > left._price ? 1 : -1) * sortOrder_1;
        case 5:
          return (parseFloat(right._buy_commission) + parseFloat(right._sell_commission) > parseFloat(left._buy_commission) + parseFloat(left._sell_commission) ? 1 : -1) * sortOrder_1;
        default:
          return right.id - left.id;
      }
    });

    return (
      <React.Fragment>
        <div className="px-4 py-2 m-2 w-full my-8">
          <Tabs
            value={this.state.selectedOrderTab}
            indicatorColor="primary"
            textColor="secondary"
            onChange={this.handleTabChangeSecondary}
          >
            <Tab classes={{
              root: classes.tabRoot,
              selected: classes.tabSelected,
            }}
              label="Open Orders"
              value={0}
            />
            <Tab classes={{
              root: classes.tabRoot,
            }}
              label="Recently Executed"
              value={1} />
            <Tab classes={{
              root: classes.tabRoot,
            }}
                 label="Transactions Summary By Broker"
                 value={2}/>
          </Tabs>
        </div>
        {this.state.selectedOrderTab === 0 &&
          <div className="px-4 py-2 m-2 w-full my-8" >
            <div className="p-12 pt-0 text-grey-lighter text-center h-64" style={{ height: '100%', overflow: 'auto' }}>
              <TextField
                id="outlined-adornment-weight"
                className={classNames(classes.margin, classes.textField)}
                variant="outlined"
                type="search"
                placeholder="SEARCH"
                InputProps={{
                  startAdornment: <InputAdornment position="end"><span className="material-icons">search</span></InputAdornment>,
                  style: {
                    color: 'black',
                    background: 'white',
                    borderRadius: 4,
                    fontSize: 12,
                    padding: 5
                  },
                }}
                // eslint-disable-next-line
                inputProps={{
                  style: {
                    padding: 5,
                  }
                }}
                InputLabelProps={{
                  style: {
                    fontSize: 12,
                    color: 'black',
                  },
                }}
                onChange={this.handleQueryChange}
              />
              <Table className={classes.table}>
                <TableHead>
                  <TableRow className={classes.row}>
                    <TableCell className={classes.cell} onClick={this.handleSort(0)}>
                    <span style={{height: 24}}>Order Placed</span>
                      {sortIndex === 0 && sortIcon}
                    </TableCell>
                    <TableCell className={classes.cell} onClick={this.handleSort(1)}>
                    <span style={{height: 24}}>Broker</span>
                      {sortIndex === 1 && sortIcon}
                    </TableCell>
                    <TableCell className={classes.cell} onClick={this.handleSort(2)}>
                    <span style={{height: 24}}>Company</span>
                      {sortIndex === 2 && sortIcon}
                    </TableCell>
                    <TableCell className={classes.cell} onClick={this.handleSort(3)}>
                    <span style={{height: 24}}>Price</span>
                      {sortIndex === 3 && sortIcon}
                    </TableCell>
                    <TableCell className={classes.cell} onClick={this.handleSort(4)}>
                    <span style={{height: 24}}>Quantity</span>
                      {sortIndex === 4 && sortIcon}
                    </TableCell>
                    <TableCell className={classes.cell} onClick={this.handleSort(5)}>
                      {sortIndex === 5 && sortIcon}
                    </TableCell>
                    <TableCell className={classes.cell} onClick={this.handleSort(6)}>
                    <span style={{height: 24}}>Type</span>
                      {sortIndex === 6 && sortIcon}
                    </TableCell>
                  </TableRow>
                </TableHead>
                  <TableBody>
                    {
                      openOrder.map(v => {
                        let currency = (typeof this.state.companies[v._company_account] !== "undefined") ? Utils.getCurrency(this.state.companies[v._company_account].currency) :  Utils.getCurrency("USD");
                        return (
                          <TableRow key={v._id} className={classes.row}>
                            <TableCell className={classes.cell} component="th" scope="row">
                              {v._ts_order_sent && moment(v._ts_order_sent).format('YYYY-MM-DD h:mm')}
                              {!v._ts_order_sent && '-'}
                            </TableCell>
                            <TableCell className={classes.cell}>{v.Authorized_Brokers[0]._name}</TableCell>
                            <TableCell className={classes.cell}>{(typeof this.state.companies[v._company_account] !== "undefined") ? this.state.companies[v._company_account]._company_symbol : ""  }</TableCell>
                            <TableCell className={classes.cell}>{currency.currency_symbol}{Utils.addThousandCommas(v._price)}</TableCell>
                            <TableCell className={classes.cell}>{Utils.addThousandCommas(v._quantity)}</TableCell>
                            <TableCell className={classes.cell}>{(typeof v['_sell_order_confirmation'] === 'undefined') ? 'BUY' : 'SELL'}</TableCell>
                            <TableCell className={classes.cell}>{v._type}</TableCell>
                          </TableRow>
                        )
                      })
                    }
                  </TableBody>
                </Table>
            </div>
          </div>
        }
        {this.state.selectedOrderTab === 1 &&
          <div className="px-4 py-2 m-2 w-full my-8" style={{height: fullHeight?'calc(100vh - 246px)':'calc(100vh - 546px)'}}>
            <div className="p-12 pt-0 text-grey-lighter text-center h-64" style={{ height: '100%', overflow: 'auto' }}>
              <TextField
                id="outlined-adornment-weight"
                className={classNames(classes.margin, classes.textField)}
                variant="outlined"
                type="search"
                placeholder="SEARCH"
                InputProps={{
                  startAdornment: <InputAdornment position="end"><span className="material-icons">search</span></InputAdornment>,
                  style: {
                    color: 'black',
                    background: 'white',
                    borderRadius: 4,
                    fontSize: 12,
                    padding: 5
                  },
                }}
                // eslint-disable-next-line
                inputProps={{
                  style: {
                    padding: 5,
                  }
                }}
                InputLabelProps={{
                  style: {
                    fontSize: 12,
                    color: 'black',
                  },
                }}
                onChange={this.handleQueryChange}
              />
              <Table className={classes.table}>
                <TableHead>
                  <TableRow className={classes.row}>
                    <TableCell className={classes.cell} onClick={this.handleSort(0)}>
                      <span style={{height: 24}}>Order Complete</span>
                    {sortIndex_1 === 0 && sortIcon_1}
                    </TableCell>
                    <TableCell className={classes.cell} onClick={this.handleSort(1)}>
                    <span style={{height: 24}}>Seller</span>
                    {sortIndex_1 === 1 && sortIcon_1}
                    </TableCell>
                    <TableCell className={classes.cell} onClick={this.handleSort(2)}>
                    <span style={{height: 24}}>Buyer</span>
                    {sortIndex_1 === 2 && sortIcon_1}
                    </TableCell>
                    <TableCell className={classes.cell} onClick={this.handleSort(3)}>
                    <span style={{height: 24}}>Qty</span>
                    {sortIndex_1 === 3 && sortIcon_1}
                    </TableCell>
                    <TableCell className={classes.cell} onClick={this.handleSort(4)}>
                    <span style={{height: 24}}>Price</span>
                    {sortIndex_1 === 4 && sortIcon_1}
                    </TableCell>
                    <TableCell className={classes.cell} onClick={this.handleSort(5)}>
                    <span style={{height: 24}}>Total Commission</span>
                    {sortIndex_1 === 5 && sortIcon_1}
                    </TableCell>
                  </TableRow>
                </TableHead>

                  <TableBody>
                    {
                      completedOrder.map(v => {
                        let currency = Utils.getCurrency(v.currency);
                        return (
                          <TableRow key={v._id} className={classes.row}>
                            <TableCell className={classes.cell} component="th" scope="row">
                              {moment(v.createdAt).format('YYYY-MM-DD h:mm')}
                            </TableCell>
                            <TableCell className={classes.cell}>{v._selling_investor_account} ({v.Selling_Broker[0]._name})</TableCell>
                            <TableCell className={classes.cell}>{v._buying_investor_account} ({v.Buying_Broker[0]._name})</TableCell>
                            <TableCell className={classes.cell}>{Utils.addThousandCommas(v._quantity)}</TableCell>
                            <TableCell className={classes.cell}>{currency.currency_symbol}{Utils.addThousandCommas(v._price)}</TableCell>
                            <TableCell className={classes.cell}>{currency.currency_symbol}{Utils.addThousandCommas((parseFloat(v._buy_commission) + parseFloat(v._sell_commission))/10)}</TableCell>
                          </TableRow>
                        )
                      })
                    }
                  </TableBody>
                </Table>
              </div>
          </div>
        }
        {this.state.selectedOrderTab === 2 &&
        <div className="px-4 py-2 m-2 w-full my-8" style={{height: fullHeight?'calc(100vh - 246px)':'calc(100vh - 546px)'}}>
          <div className="p-12 pt-0 text-grey-lighter text-center h-64" style={{ height: '100%', overflow: 'auto' }}>
            <TextField
                id="outlined-adornment-weight"
                className={classNames(classes.margin, classes.textField)}
                variant="outlined"
                type="search"
                placeholder="SEARCH"
                InputProps={{
                  startAdornment: <InputAdornment position="end"><span className="material-icons">search</span></InputAdornment>,
                  style: {
                    color: 'black',
                    background: 'white',
                    borderRadius: 4,
                    fontSize: 12,
                    padding: 5
                  },
                }}
                // eslint-disable-next-line
                inputProps={{
                  style: {
                    padding: 5,
                  }
                }}
                InputLabelProps={{
                  style: {
                    fontSize: 12,
                    color: 'black',
                  },
                }}
                onChange={this.handleQueryChange}
            />
            <Table className={classes.table}>
              <TableHead>
                <TableRow className={classes.row}>
                  {(!this.props.selectedCompany) &&
                    <TableCell className={classes.cell} onClick={this.handleSort(0)}>
                      <span style={{height: 24}}>Company</span>
                    </TableCell>
                  }
                  <TableCell className={classes.cell} onClick={this.handleSort(0)}>
                    <span style={{height: 24}}>Executions</span>
                  </TableCell>
                  <TableCell className={classes.cell} onClick={this.handleSort(1)}>
                    <span style={{height: 24}}>Buy Broker</span>
                  </TableCell>
                  <TableCell className={classes.cell} onClick={this.handleSort(2)}>
                    <span style={{height: 24}}>Units</span>
                  </TableCell>
                  <TableCell className={classes.cell} onClick={this.handleSort(3)}>
                    <span style={{height: 24}}>Value</span>
                  </TableCell>
                  <TableCell className={classes.cell} onClick={this.handleSort(4)}>
                    <span style={{height: 24}}>Commission</span>
                  </TableCell>
                  <TableCell className={classes.cell} onClick={this.handleSort(5)}>
                    <span style={{height: 24}}>Sell Broker</span>
                  </TableCell>
                </TableRow>
              </TableHead>

                <TableBody>
                  {
                    this.state.cross_broker.map(v => {
                      let currency = Utils.getCurrency(v.currency);
                      return (
                          <TableRow key={v._id} className={classes.row}>
                            {(!this.props.selectedCompany) &&
                              <TableCell className={classes.cell}>{v.company}</TableCell>
                            }
                            <TableCell className={classes.cell}>{v.executions}</TableCell>

                            <TableCell className={classes.cell}>{v.buyer}</TableCell>
                            <TableCell className={classes.cell}>{Utils.addThousandCommas(v.units)}</TableCell>

                            <TableCell className={classes.cell}>{currency.currency_symbol}{Utils.addThousandCommas(v.value)}</TableCell>
 
                            <TableCell className={classes.cell}>{currency.currency_symbol}{Utils.addThousandCommas((parseFloat(v.sell_commision) + parseFloat(v.buy_commission))/10)}</TableCell>
                            <TableCell className={classes.cell}>{v.seller}</TableCell>
                          </TableRow>
                      )
                    })
                  }
                </TableBody>
              </Table>
            </div>
        </div>
        }
      </React.Fragment>
    )
  }
}
function mapStateToProps({ fuse, auth }) {
  return {
    login: auth.login,
    user: auth.user
  }
}
export default withStyles(styles, { withTheme: true })(connect(mapStateToProps)(withRouter(OrderList)));



// WEBPACK FOOTER //
// ./src/main/content/dashboard/components/OrderList.js